import { GameId, ProductV2, isStoreOfferProduct } from '@common'
import { useTranslations } from 'next-intl'

import { useGameSlug } from '@/features/storefronts/game-provider'

import { isNormalOffer } from '..'
import { CardOffer } from '../../_storeBase/card/CardOffer'
import { ProductCategory } from '../Products/ProductCategory'
import OffersHeader from './OffersHeader'

import styles from './Offers.module.scss'

interface OffersProps {
  products: ProductV2[]
  theme: GameId
}

const Offers = ({ products }: OffersProps) => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const offers = products.filter(isStoreOfferProduct).filter(isNormalOffer)

  return (
    <div className={styles.offers} style={{ backgroundImage: `url('/images/clashroyale/offers-bg.png')` }}>
      <OffersHeader />
      <div className={styles.offersContainer}>
        {offers.map((offer, index) => (
          <CardOffer key={index} game={gameSlug} product={offer} />
        ))}
      </div>
      <ProductCategory title={t('game_cat_gems')} products={products} productType="GEM" />
    </div>
  )
}

export default Offers
